import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type SaveAppointmentSignatureOptions = {
  appointmentId: string;
  covid19Signed: string;
  template: string;
};

const saveAppointmentSignature = async ({
  appointmentId,
  covid19Signed,
  template,
}: SaveAppointmentSignatureOptions) => {
  const config: AxiosRequestConfig = {
    url: `/covid19/appointment/${appointmentId}/settings`,
    method: 'post',
    data: {
      appointmentId,
      covid19Signed,
      template,
    },
  };

  await axios.request<void>(config);
};

export default saveAppointmentSignature;
